import { css } from '@emotion/react';
import { ReactElement } from 'react';

import { styled } from '../../styled';

const styles = css`
	font-size: 12px;
	font-weight: 400;
	padding-bottom: 8px;
	text-align: center;

	&,
	& a {
		color: #afb3c0;
	}
`;

const Component = ({ className }: { className: string }): ReactElement => (
	<div className={className}>
		Работает на платформе{' '}
		<a target="_blank" rel="noreferrer" href="https://naumen.ru">
			Naumen Contact Center
		</a>
	</div>
);

export const Copyright = styled(Component)(styles);
